import { NgModule } from '@angular/core';
import { UserStoreModule } from './store/user-store.module';

@NgModule({
  imports: [UserStoreModule],
})
export class UserDataAccessModule {}
